import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import ModuleListPage from "./Pages/ModuleListPage";
import CoursesListPage from "./Pages/CoursesListPage";
import IntroTestPage from "./Pages/IntroTestPage";
import CourseDescriptionPage from "./Pages/CourseDescriptionPage";
import Header from "./Components/Semantics/Header";
import Footer from "./Components/Semantics/Footer";
import TestResultPage from "./Pages/TestResultPage";
import ModulePage from "./Pages/ModulePage";
import TopicPage from "./Pages/TopicPage";
import AuthorCoursesPage from "./Pages/AuthorCoursesPage";
import Menu from "./Components/Semantics/Menu";
import BreadCrumbs from "./Components/Semantics/BreadCrumbs";
import StyledButton from "./Components/UI/StyledButton";
import { useEffect, useState } from "react";
import Login from "./Components/Modules/Autorization/Login";
import Account from "./Pages/Account";
import Registration from "./Components/Modules/Autorization/Registration";
import CertificatForm from "./Components/Modules/CertificatForm/CertificatForm";
import ModuleTestPage from "./Pages/ModuleTestPage";
import CertificatTestPage from "./Pages/CertificatTestPage";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [openLogin, setOpenLogin] = useState(false);
  const [openRegistration, setOpenRegistration] = useState(false);

  function onAutorization() {
    if (location.pathname !== "/account") {
      if (sessionStorage.getItem("token")) {
        window.scrollTo(0, 0);
        navigate("/account");
      } else {
        setOpenLogin(true);
      }
    } else {
      sessionStorage.removeItem("token");

      window.scrollTo(0, 0);
      navigate("/");
    }
  }

  return (
    <div className="App">
      <Header />
      <Menu />
      <BreadCrumbs />
      <div className="autorizationBox">
        {location.pathname !== "/account" ? (
          <StyledButton
            text={
              sessionStorage.getItem("token") ? "ЛИЧНЫЙ КАБИНЕТ" : "АВТОРИЗАЦИЯ"
            }
            onClick={onAutorization}
          />
        ) : (
          <StyledButton text={"ВЫХОД"} onClick={onAutorization} />
        )}
      </div>
      <Routes>
        <Route path="/" element={<CoursesListPage />} />
        <Route path="/course" element={<CourseDescriptionPage />} />
        <Route path="/modules" element={<ModuleListPage />} />
        <Route path="/intro_test" element={<IntroTestPage />} />
        <Route path="/modules/module/test" element={<ModuleTestPage />} />
        <Route path="/modules/module/certificat_test" element={<CertificatTestPage />} />
        <Route path="/intro_test/result" element={<TestResultPage />} />
        <Route path="/modules/module" element={<ModulePage />} />
        <Route path="/modules/module/topic" element={<TopicPage />} />
        <Route path="/author_courses" element={<AuthorCoursesPage />} />
        <Route path="/account" element={<Account />} />
      </Routes>
      <Footer />
      {openLogin && (
        <Login
          close={(e: boolean) => setOpenLogin(e)}
          reg={(e: boolean) => setOpenRegistration(e)}
        />
      )}
      {openRegistration && (
        <Registration
          close={(e: boolean) => setOpenRegistration(e)}
          login={(e: boolean) => setOpenLogin(e)}
        />
      )}
    </div>
  );
}

export default App;
